'use client'

import * as React from 'react'

export type PaymentsAppType = 'studio' | 'marketplace'

export const PaymentsAppTypeContext = React.createContext<PaymentsAppType>('marketplace')

export function usePaymentsAppType(): PaymentsAppType {
  return React.useContext(PaymentsAppTypeContext)
}

/**
 * Derive the analytics `location` field from the app type context.
 * Replaces the old `decideModalLocation()` URL-sniffing utility.
 */
export function getModalLocation(appType: PaymentsAppType): string {
  if (appType === 'studio') {
    return 'studio'
  }
  if (typeof window !== 'undefined' && window.location.pathname.includes('/product/')) {
    return 'pdp'
  }
  return 'rest'
}
